import React, { useState, useRef } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the plugin for jsPDF
import IconButton from '../../elements/IconButton';
import Button from '../../elements/Button';
import ExcelJS from 'exceljs';


const Main = (props) => {
    const [loadedData, setLoadedData] = useState([]);
    const [stillGettingData, setStillGettingData] = useState(0);
    const isCancelled = useRef(false); // Used to track if fetching was cancelled

    console.log(props)

    console.log(props)

    const handleCancelFetch = () => {
        isCancelled.current = true; // Set flag to true when fetching is cancelled
    };

    const fetchAllData = (exportType) => {
        let skip = 0;
        const limit = 999999;
        let allData = [];
        setStillGettingData(1);

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({
                admin_ID: props.adminId,
            })
        };

        props.tokenSafeAPIRequest(
            `${props.url}${props.specific ? '/' + props.specific : ''}?limit=${limit}&fetch_links=true&skip=${skip}&sort_field=${props.sort}&start_date=${props.calStartDate}&end_date=${props.calEndDate}&active_only=false`,
            requestOptions,
            '',
            (result, status) => {
                if (exportType === 'CSV') {
                    downloadCSV(result, props.exportKeys, props.fileTitle);
                } else if (exportType === 'PDF') {
                    downloadPDF(result, props.exportKeys, props.fileTitle);
                } else if (exportType === 'EXCEL') {
                    downloadEXCEL(result, props.exportKeys, props.fileTitle);
                } 
            })


    };

    const processResult = (data, onCompletion) => {
        console.log(data)
        if (data && data.length > 0) {
            setLoadedData((loadedData) => [...loadedData, ...data]);
            onCompletion(true, data);
        } else {
            onCompletion(false);
        }
    };

    function formatNumber(value) {
        try {
            // Attempt to convert the input to a number
            const num = parseFloat(value);
            // Check if the conversion resulted in a valid number
            if (!isNaN(num)) {
              // Use Intl.NumberFormat for US-style number formatting with two decimal places
              return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(num);
            } else {
              // Return a default value if the input is not a valid number
              return '0.00';
            }
          } catch (e) {
            // In case of any unexpected errors, return a default value
            return '0.00';
          }
    }

    const formatShortDate = (value) => {
        if (!value) return '';

        const trimmedValue = `${value}`.trim();
        if (!trimmedValue) return '';

        const datePart = trimmedValue.split('T')[0];
        if (!datePart) return trimmedValue;

        const [year, month, day] = datePart.split('-').map(Number);
        if (!year || !month || !day) return trimmedValue;

        return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('en-US', {
            timeZone: 'UTC',
            month: '2-digit',
            day: '2-digit',
            year: '2-digit',
        });
    };

    const convertPayeeToUser = (payee, user, spiffee, dealership) => {
        if (payee === null) {return 'No User'}
        if (payee === 0) {return spiffee.name}
        if (payee === 1) {return dealership.name}
        if (payee === 2) {return user === null ? 'No Agent':(user?.first_name + ' ' + user?.last_name)}
        if (payee === 3) {return 'Inside Sales'}
    }

    const getExportDealer = (dealership, split) => {
        const dealerName = dealership?.name || (typeof dealership === 'string' ? dealership : '');
        return {
            ...(typeof dealership === 'object' && dealership ? dealership : {}),
            name: split ? `${dealerName} - (Split)` : dealerName,
        };
    };

    const getExportAgent = (agents, split) => {
        const agentList = Array.isArray(agents) ? agents : [];
        return split
            ? { name: agentList
                .map((agent) => agent?.name
                    ? `${agent.name}${agent.percent != null ? ` - ${agent.percent}%` : ''}`
                    : null)
                .filter(Boolean)
                .join(', ') }
            : (agentList[0] || { name: '' });
    };

    const isEntryMonthLessThanSevenMonths = (entryMonth) => {
        if (!entryMonth) return false;

        const [year, month] = entryMonth.split('-').map(Number);
        if (!year || !month) return false;

        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1;
        const monthsDiff = (currentYear - year) * 12 + (currentMonth - month);

        return monthsDiff >= 0 && monthsDiff < 7;
    };

    const downloadCSV = (data, keys, filename = 'data.csv') => {
        const rows = Array.isArray(data?.dealerships)
            ? data.dealerships.flatMap((dealer) =>
                dealer.rows.map((row) => ({
                    ...row,
                    dealer: getExportDealer(dealer.dealership, dealer.split),
                    agent: getExportAgent(dealer.agents, dealer.split),
                    contract_type: row.contract_type_label || row.contract_type,
                }))
            )
            : [];

        const csvLines = [];
        csvLines.push(['Admin', 'Range Start', 'Range End', 'Total Contracts']);
        csvLines.push([data.admin?.name || '', formatShortDate(data.range_start), formatShortDate(data.range_end), data.total_contract_count ?? '']);
        csvLines.push([]);
        csvLines.push(['Dealer', 'Agent', 'Confirmed', 'Contract/m', '$/c', 'AVG. Spiff/c', 'Net/c', 'Net/m', 'CBA cc', 'CBA cc/m', 'Contract Type']);

        rows.forEach((row) => {
            csvLines.push([
                row.dealer?.name || '',
                row.agent?.name || '',
                row.confirmed ?? '',
                row.contracts_per_month ?? '',
                row.contract_gross ?? '',
                row.avg_spiff_per_contract ?? '',
                row.net_per_contract ?? '',
                row.net_per_month ?? '',
                row.cba_cc ?? '',
                row.cba_cc_per_month ?? '',
                row.contract_type ?? '',
            ]);
        });

        const escapeCsvValue = (value) => {
            const stringValue = value == null ? '' : String(value);
            return `"${stringValue.replace(/"/g, '""')}"`;
        };

        const csvContent = csvLines
            .map((line) => line.map(escapeCsvValue).join(','))
            .join('\r\n');
    
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };
    
    const downloadPDF = (data, keys, filename = 'data.pdf') => {
        const doc = new jsPDF({ orientation: 'landscape' });
        const headerLines = [
            `${data.admin?.name || ''}`,
            `${formatShortDate(data.range_start)}`,
            `${formatShortDate(data.range_end)}`,
            `Total Contracts: ${data.total_contract_count ?? ''}`,
            `Total CBA CC: ${data.total_cba_cc ?? ''}`,
        ];

        const headerStartY = 10;
        const headerLineHeight = 6;
        const leftMargin = 14;
        const rightMargin = 14;
        const availableWidth = doc.internal.pageSize.getWidth() - leftMargin - rightMargin;
        const gap = 8;

        let currentX = leftMargin;
        let currentY = headerStartY;

        headerLines.forEach((line) => {
            const textWidth = doc.getTextWidth(line);
            if (currentX + textWidth > leftMargin + availableWidth) {
                currentX = leftMargin;
                currentY += headerLineHeight;
            }

            doc.text(line, currentX, currentY);
            currentX += textWidth + gap;
        });

        console.log(data)

        const addPageNumbers = (doc) => {
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;
            const pageWidth = pageSize.width;

            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(`Page ${i}`, pageWidth - 30, pageHeight - 10);
            }
        };

        let rows = []
        const mainTableStartY = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 10 : 32.5;

        data.dealerships.forEach((dealer) => {
            const updatedRows = dealer.rows.map((row) => ({
                ...row,
                dealer: getExportDealer(dealer.dealership, dealer.split),
                agent: getExportAgent(dealer.agents, dealer.split),
                contract_type: row.contract_type_label || row.contract_type,
                entry_month: dealer.entry_month,
            }));
            rows.push(...updatedRows);
        });

        console.log(rows)

        const transactionsTableData = [];
        const rowStyles = []; // Store custom style for each row
        let lastUserId = null;

        let total = 0;

        console.log(data)

        rows.forEach((r) => {
            const dealerName = r.dealer?.name || '';
            const dealerNameWithFlag = isEntryMonthLessThanSevenMonths(r.entry_month)
                ? `${dealerName} - Less Than 7`
                : dealerName;

            transactionsTableData.push([
                dealerNameWithFlag,
                r.dealer?.inside_sales ? 'Y' : 'N',
                r.agent?.name || '',
                r.confirmed,
                r.contracts_per_month,
                r.contract_gross,
                r.avg_spiff_per_contract,
                r.net_per_contract,
                r.net_per_month,
                r.cba_cc,
                r.cba_cc_per_month,
                r.contract_type_label || r.contract_type,
            ]);

        });

        doc.autoTable({
            startY: 32.5,
            head: [['Dealer', 'IS' ,'Agent', 'Confirmed', 'Contract/m', '$/c', 'AVG. Spiff/c', 'Net/c', 'Net/m', 'CBA cc', 'CBA cc/m', 'Contract Type']],
            body: transactionsTableData,
            styles: {
                lineColor: [200, 200, 200],
                lineWidth: 0.1,
            },
            bodyStyles: {
                fillColor: false,
            },
            headStyles: {
                fillColor: false,
                textColor: 0,
                lineColor: [200, 200, 200],
                lineWidth: 0.1,
            },
            tableLineColor: [200, 200, 200],
            tableLineWidth: 0.1,

            // Apply per-row custom styling
            willDrawCell: function(data) {
                const rowInfo = transactionsTableData[data.row.index];
                if (rowInfo?.isAgentEnd) {
                    data.cell.styles.lineWidth = { top: 0.1, right: 0.1, bottom: 2.0, left: 0.1 };
                    data.cell.styles.lineColor = { bottom: [255,255,255] };
                }
            }
        });

        // doc.text(`Total: $` + formatNumber(total), 14, doc.lastAutoTable.finalY + 30);

        addPageNumbers(doc);
        doc.save(filename);
    };

    const downloadEXCEL = async (
        data,
        keys,
        filename = 'data.xlsx',
        organizationName = data.admin?.name,
    ) => {
        const contractRows = Array.isArray(data?.dealerships)
            ? data.dealerships.flatMap((dealer) =>
                (dealer.rows || []).map((row) => ({
                    ...row,
                    dealer: getExportDealer(
                        dealer.dealership,
                        dealer.split
                    ),
                    agent: getExportAgent(dealer.agents, dealer.split),
                    contract_type:
                        row.contract_type_label || row.contract_type,
                }))
            )
            : [];

        const agentSummary = data?.agents_summary || {};

        const summaryRows = Array.isArray(agentSummary.agents)
            ? agentSummary.agents.map((row) => [
                row.agent?.name || '',
                row.cba_cc ?? '',
                row.sign_ups ?? '',
            ])
            : [];

        if (agentSummary.house) {
            summaryRows.push([
                'House',
                agentSummary.house.cba_cc ?? '',
                agentSummary.house.sign_ups ?? '',
            ]);
        }

        if (agentSummary.total) {
            summaryRows.push([
                'Total',
                agentSummary.total.cba_cc ?? '',
                agentSummary.total.sign_ups ?? '',
            ]);
        }

        const detailRows = contractRows.map((row) => [
            row.dealer?.name || '',
            row.agent?.name || '',
            row.confirmed ?? '',
            row.contracts_per_month ?? '',
            row.contract_gross ?? '',
            row.avg_spiff_per_contract ?? '',
            row.net_per_contract ?? '',
            row.net_per_month ?? '',
            row.cba_cc ?? '',
            row.cba_cc_per_month ?? '',
            row.contract_type ?? '',
        ]);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('CBA Report', {
            views: [{ showGridLines: false }],
        });

        // Report title
        worksheet.mergeCells('A1:C1');
        worksheet.getCell('A1').value =
            `${organizationName} - CBA Contracts & Sign Ups`;
        worksheet.getCell('A1').font = {
            bold: true,
            size: 16,
            color: { argb: 'FFFFFFFF' },
        };
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF1F4E78' },
        };
        worksheet.getCell('A1').alignment = {
            horizontal: 'center',
            vertical: 'middle',
        };
        worksheet.getRow(1).height = 26;

        // Date range
        worksheet.mergeCells('A2:C2');
        worksheet.getCell('A2').value =
            `${formatShortDate(data.range_start)} - ` +
            `${formatShortDate(data.range_end)}`;
        worksheet.getCell('A2').font = {
            bold: true,
            italic: true,
        };
        worksheet.getCell('A2').alignment = {
            horizontal: 'center',
        };

        // Agent summary table
        const summaryStartRow = 4;

        worksheet.addTable({
            name: 'AgentSummary',
            ref: `A${summaryStartRow}`,
            headerRow: true,
            totalsRow: false,
            style: {
                theme: 'TableStyleMedium2',
                showRowStripes: true,
            },
            columns: [
                { name: 'Agent' },
                { name: 'Contracts' },
                { name: 'Signups' },
            ],
            rows: summaryRows,
        });

        summaryRows.forEach((row, index) => {
            const worksheetRow = summaryStartRow + index + 1;

            worksheet.getCell(worksheetRow, 2).numFmt = '0.##';
            worksheet.getCell(worksheetRow, 3).numFmt = '0';

            if (row[0] === 'Total') {
                worksheet.getRow(worksheetRow).font = { bold: true };
            }
        });

        // Admin information
        const adminHeaderRow =
            summaryStartRow + summaryRows.length + 3;

        worksheet.getRow(adminHeaderRow).values = [
            'Admin',
            'Range Start',
            'Range End',
            'Total Contracts',
        ];

        worksheet.getRow(adminHeaderRow + 1).values = [
            data.admin?.name || '',
            formatShortDate(data.range_start),
            formatShortDate(data.range_end),
            data.total_contract_count ?? '',
        ];

        worksheet.getRow(adminHeaderRow).eachCell((cell) => {
            cell.font = {
                bold: true,
                color: { argb: 'FFFFFFFF' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF4472C4' },
            };
            cell.alignment = {
                horizontal: 'center',
            };
        });

        // Detailed contracts table
        const detailStartRow = adminHeaderRow + 3;

        worksheet.addTable({
            name: 'ContractDetails',
            ref: `A${detailStartRow}`,
            headerRow: true,
            totalsRow: false,
            style: {
                theme: 'TableStyleMedium9',
                showRowStripes: true,
            },
            columns: [
                { name: 'Dealer' },
                { name: 'Agent' },
                { name: 'Confirmed' },
                { name: 'Contract/m' },
                { name: '$/c' },
                { name: 'AVG. Spiff/c' },
                { name: 'Net/c' },
                { name: 'Net/m' },
                { name: 'CBA cc' },
                { name: 'CBA cc/m' },
                { name: 'Contract Type' },
            ],
            rows: detailRows,
        });

        // Column widths
        const columnWidths = [
            28, 28, 14, 16, 14, 18, 14, 14, 14, 16, 22,
        ];

        columnWidths.forEach((width, index) => {
            worksheet.getColumn(index + 1).width = width;
        });

        // Detail number formats
        detailRows.forEach((_, index) => {
            const rowNumber = detailStartRow + index + 1;

            worksheet.getCell(rowNumber, 4).numFmt = '0.##';
            worksheet.getCell(rowNumber, 5).numFmt = '$#,##0.00';
            worksheet.getCell(rowNumber, 6).numFmt = '$#,##0.00';
            worksheet.getCell(rowNumber, 7).numFmt = '$#,##0.00';
            worksheet.getCell(rowNumber, 8).numFmt = '$#,##0.00';
            worksheet.getCell(rowNumber, 9).numFmt = '0.##';
            worksheet.getCell(rowNumber, 10).numFmt = '0.##';
        });

        const buffer = await workbook.xlsx.writeBuffer();

        const blob = new Blob([buffer], {
            type:
                'application/vnd.openxmlformats-officedocument.' +
                'spreadsheetml.sheet',
        });

        const excelFilename = filename.toLowerCase().endsWith('.xlsx')
            ? filename
            : `${filename.replace(/\.[^.]+$/, '')}.xlsx`;

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = excelFilename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => URL.revokeObjectURL(url), 0);
    };
    
    return (
        <div style={{ width: '360px', height: 'auto', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flexBasis: '10%', display: 'flex', flexDirection: 'row' }}>
                <span style={{ fontWeight: '500', fontSize: '20px', flexBasis: '99%' }}>Export Report</span>
                <IconButton img={false} colors={props.colors} Style={{ borderRadius: '3px', backgroundColor: props.colors.border, width: '24px' }} size="16px">
                    <div onClick={() => { handleCancelFetch(); props.setIsOpen() }} style={{ paddingLeft: '3px', paddingRight: '3px' }}><span onClick={() => { handleCancelFetch(); props.setIsOpen() }}>x</span></div>
                </IconButton>
            </div>
            <div style={{ flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <span style={{ fontWeight: '500', fontSize: '16px' }}>Downloaded Rows: {loadedData.length}</span>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('CSV')}>Download CSV</Button>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('PDF')}>Download PDF</Button>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('EXCEL')}>Download EXCEL - Expanded</Button>
            </div>
        </div>
    );
};

export default Main;
